// Configuración de GoHighLevel
export const GOHIGHLEVEL_CONFIG = {
  API_URL: 'https://services.leadconnectorhq.com',
  LOCATION_ID: process.env.REACT_APP_GOHIGHLEVEL_LOCATION_ID,
  API_KEY: process.env.REACT_APP_GOHIGHLEVEL_API_KEY,
  PIPELINE_ID: process.env.REACT_APP_GOHIGHLEVEL_PIPELINE_ID,
  STAGE_ID: process.env.REACT_APP_GOHIGHLEVEL_STAGE_ID,
  ASSIGNED_TO: process.env.REACT_APP_GOHIGHLEVEL_ASSIGNED_TO,
};

// Validación de configuración
export const validateConfig = () => {
  const requiredFields = ['LOCATION_ID', 'API_KEY', 'PIPELINE_ID', 'STAGE_ID', 'ASSIGNED_TO'];
  const missingFields = requiredFields.filter(field => !GOHIGHLEVEL_CONFIG[field]);
  
  if (missingFields.length > 0) {
    throw new Error(`Missing required GoHighLevel configuration: ${missingFields.join(', ')}`);
  }
}; 